var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtmlIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "htmlIcon_svg__Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".htmlIcon_svg__st0{fill:#f47822}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "htmlIcon_svg__XMLID_529_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "htmlIcon_svg__st0",
    d: "M365.6 285.9H40.3v133.9h276.3l49-133.9zm-235.1 94.5h-9.2V357H96.8v23.5h-9.2v-55h9.2v24.2h24.6v-24.2h9.2v54.9zm51.2-47.6h-17v47.6h-9.2v-47.6h-16.7v-7.4h42.9v7.4zm65 47.6h-9.2v-39.5h-.2l-15.1 39.6h-6.3l-15.4-40.3-.2.1v40.2H191v-55h12.1l15.8 42.3h.2l15.9-42.3h11.7v54.9zm48.9 0h-34.9v-55h9.2v47.7h25.8v7.3z",
    id: "htmlIcon_svg__XMLID_533_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "htmlIcon_svg__st0",
    d: "M352.9 6H107.4c-7.3 0-13.3 6-13.3 13.3v256.8h26.6V32.6h232.2v92.2h92.2v354.6H120.7v-49.8H94.1v63.1c0 7.3 6 13.3 13.3 13.3h351c7.3 0 13.3-6 13.3-13.3V124.8L352.9 6z",
    id: "htmlIcon_svg__XMLID_532_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "htmlIcon_svg__st0",
    id: "htmlIcon_svg__XMLID_531_",
    d: "M156.2 171.4h253.4V191H156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "htmlIcon_svg__st0",
    id: "htmlIcon_svg__XMLID_530_",
    d: "M156.2 209.5h213.3v19.6H156.2z"
  }))));
}
export default __webpack_public_path__ + "3811e5863000071f61d69e3671f9e5ad.svg";
export { SvgHtmlIcon as ReactComponent };